function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#A6AFB8"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1 8c.552 0 1-.448 1-1V3c0-.552.448-1 1-1h4c.552 0 1-.448 1-1s-.448-1-1-1H3C1.343 0 0 1.343 0 3v4c0 .552.448 1 1 1M7 28H3c-.552 0-1-.447-1-1v-4c0-.553-.448-1-1-1s-1 .447-1 1v4c0 1.657 1.343 3 3 3h4c.552 0 1-.447 1-1 0-.553-.448-1-1-1M29 22c-.553 0-1 .447-1 1v4c0 .553-.447 1-1 1h-4c-.553 0-1 .447-1 1 0 .553.447 1 1 1h4c1.657 0 3-1.343 3-3v-4c0-.553-.447-1-1-1M27 0h-4c-.553 0-1 .448-1 1s.447 1 1 1h4c.553 0 1 .448 1 1v4c0 .552.447 1 1 1 .553 0 1-.448 1-1V3c0-1.657-1.343-3-3-3M29 14H16V1c0-.552-.448-1-1-1s-1 .448-1 1v13H1c-.552 0-1 .448-1 1s.448 1 1 1h13v13c0 .553.448 1 1 1s1-.447 1-1V16h13c.553 0 1-.448 1-1s-.447-1-1-1",
  transform: "translate(-317 -172) translate(317 172)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 4h4c1.104 0 2 .896 2 2v4c0 1.104-.896 2-2 2h-4c-1.104 0-2-.896-2-2V6c0-1.104.896-2 2-2M20 18h4c1.104 0 2 .896 2 2v4c0 1.104-.896 2-2 2h-4c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2M6 18h4c1.104 0 2 .896 2 2v4c0 1.104-.896 2-2 2H6c-1.104 0-2-.896-2-2v-4c0-1.104.896-2 2-2M6 4h4c1.104 0 2 .896 2 2v4c0 1.104-.896 2-2 2H6c-1.104 0-2-.896-2-2V6c0-1.104.896-2 2-2",
  transform: "translate(-317 -172) translate(317 172)"
}))));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30"
}, props), _ref);

export default __webpack_public_path__ + "static/media/qr-code.cba38cc0.svg";
export { SvgComponent as ReactComponent };